import React, {useState} from 'react'
import {Form, Header} from "semantic-ui-react";

const LegalTerms = (props) => {
    const [terms, setTerms] = useState(false);
    const [privacy, setPrivacy] = useState(false);

    const submitForm = (e) => {
        props.setStep("photo");
    }

    return (
        <div>
            <Header as='h2'>Legal Terms</Header>
            <div><strong>Terms of Use:</strong></div>
            <iframe title="terms" style={{width: '100%', height: '20em'}} src='https://legal.plexusintl.com/terms/noframe/'></iframe>
            <p><a href='https://legal.plexusintl.com/terms/' target='_blank'>View Terms of Use Policy</a></p>

            <div><strong>Data Privacy & Protection:</strong></div>
            <iframe title="privacy" style={{width: '100%', height: '20em'}} src='https://legal.plexusintl.com/privacy/noframe/'></iframe>
            <p><a href='https://legal.plexusintl.com/privacy/' target='_blank'>View Data Privacy & Protection Policy</a></p>

            <p style={{marginTop: '3em'}}><strong>Acknowledgement of the IATF ADP Terms of Use by an individual and/or a sponsoring certification body constitutes acceptance, agreement and understanding that any violation of any section of these Terms of Use constitutes grounds for loss of IATF-recognition for the certification body and loss of IATF-issued auditor credentials for the individual auditor involved.  Potential IATF actions are defined in the IATF Rules for Achieving IATF 16949 Recognition.  This acknowledgement further extends to certification bodies and /or auditors having knowledge of actions and/or activities in violation of these terms of use for failing to disclose any violation.</strong></p>

            <p><strong>By accepting these terms, you further acknowledge that you are the auditor named in this account and that you are not completing this registration process on behalf of anyone else.</strong></p>

            <Form size='large' style={{marginTop: '2em'}} onSubmit={submitForm}>
                <Form.Checkbox checked={terms} onChange={(e) => setTerms(!terms)} required label='I agree that I have read the Terms and Conditions, that I am the person named on this account, and that I accept all the conditions outlined above.' />
                <Form.Checkbox checked={privacy} onChange={(e) => setPrivacy(!privacy)} required label='I agree that I have read the Data Privacy and Protection Policy and that I accept the way my personal information will being used on the IATF ADP sites.' />
                <Form.Button disabled={terms === false || privacy === false} type='submit'>Next Step</Form.Button>
            </Form>
        </div>
    )
}

export default LegalTerms;